module.exports = __webpack_public_path__ + "static/media/BlockProduct.99146369.svg";